import { apiClient } from '@/lib/api/client'
import type { Account } from '@/types'

export const getAccounts = async (): Promise<Account[]> => {
  const { data } = await apiClient.get('/api/accounts/')
  return data
}

export interface CreateAccountPayload {
  name: string
  current_balance: number
  is_savings_account: boolean
  currency: Account['currency']
}

export const createAccount = async (payload: CreateAccountPayload): Promise<Account> => {
  const { data } = await apiClient.post('/api/accounts/', payload)
  return data
}

export interface UpdateAccountPayload {
  id: number
  name?: string
  currency?: Account['currency']
  is_savings_account?: boolean
  is_active?: boolean
}

export const updateAccount = async (payload: UpdateAccountPayload): Promise<Account> => {
  const { id, ...dataPayload } = payload
  const { data } = await apiClient.patch(`/api/accounts/${id}/`, dataPayload)
  return data
}

export const deleteAccount = async (id: number): Promise<void> => {
  await apiClient.delete(`/api/accounts/${id}/`)
}

